<template>
<div class="container accordion padding-right-left-0">
    <div v-if="allRecentQuotes.length === 0" class="alert alert-warning box-shadow margin-top-40 box-round mr-auto ml-auto" role="alert">
        <div class="row">
            <div class="col-2">
                <i class="material-icons">format_list_bulleted</i>
            </div>
            <div class="col-10">
                <h4 class="font-md"><strong>Ooops, too bad ...</strong></h4>
                <p class="margin-bottom-0">
                    There are no quotes right now.
                </p>
            </div>
        </div>
        <hr style="margin: 1.6rem 0">
        <p>
            Give us some time to create the proposal that your clients are going to love. Our undercover super agents are working on it ...
        </p>
    </div>

    <!-- All Recent Quotes -->
    <div v-if="allRecentQuotes.length > 0" class="card">
        <div class="card-header">
            <h2 class="mb-0">
                <button class="btn btn-link w-100 link-style" data-toggle="collapse" data-target="#all-recent-quotes" aria-expanded="true">
                    <span class="row justify-content-between">
                        <span class="col-auto text-left">All recent quotes</span>
                        <span class="col-auto text-right"><i class="material-icons align-middle">keyboard_arrow_down</i></span>
                    </span>
                </button>
            </h2>
        </div>
        <div id="all-recent-quotes" class="collapse show">
            <div class="card-body">
                <h1 class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">All recent quotes</h1>
                <div class="box-element box-shadow bg-white margin-top-20 margin-bottom-0 rounded">
                    <div class="box-element-info">
                        <div class="table-responsive-md margin-top-40">
                            <recent-quotes-table :data="allRecentQuotes"></recent-quotes-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- By Nights Stay -->
    <div v-if="Object.keys(byNightsStay).length > 0" class="card">
        <div class="card-header">
            <h2 class="mb-0">
                <button class="btn btn-link w-100 link-style" data-toggle="collapse" data-target="#by-nights-stay-quotes" aria-expanded="true">
                    <span class="row justify-content-between">
                        <span class="col-auto text-left">By nights stay</span>
                        <span class="col-auto text-right"><i class="material-icons align-middle">keyboard_arrow_down</i></span>
                    </span>
                </button>
            </h2>
        </div>
        <div id="by-nights-stay-quotes" class="collapse">
            <div class="card-body">
                <h1 class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">By night stay</h1>
                <div class="box-element box-shadow bg-white margin-top-20 margin-bottom-0 rounded">
                    <div class="box-element-info">
                        <div v-for="(data, nights) in byNightsStay" class="card">
                            <div class="card-header">
                                <h2 class="mb-0">
                                    <button class="btn btn-link w-100 link-style" data-toggle="collapse" :data-target="'#by-nights-stay-quotes-'+nights" aria-expanded="true">
                                        <span class="row justify-content-between">
                                            <span class="col-auto text-left">{{ nights }} Nights Stays</span>
                                            <span class="col-auto text-right"><i class="material-icons align-middle">keyboard_arrow_down</i></span>
                                        </span>
                                    </button>
                                </h2>
                            </div>
                            <div :id="'by-nights-stay-quotes-'+nights" class="collapse">
                                <div class="card-body">
                                    <h1 class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">{{ nights }} Nights Stays</h1>
                                    <div class="box-element box-shadow bg-white margin-top-20 margin-bottom-0 rounded">
                                        <div class="box-element-info">
                                            <div class="table-responsive-md margin-top-40">
                                                <recent-quotes-table :data="data"></recent-quotes-table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- By Budget -->
    <div v-if="Object.keys(byNightsStay).length > 0" class="card">
        <div class="card-header">
            <h2 class="mb-0">
                <button class="btn btn-link w-100 link-style" data-toggle="collapse" data-target="#by-budget-quotes" aria-expanded="true">
                    <span class="row justify-content-between">
                        <span class="col-auto text-left">By budget</span>
                        <span class="col-auto text-right"><i class="material-icons align-middle">keyboard_arrow_down</i></span>
                    </span>
                </button>
            </h2>
        </div>
        <div id="by-budget-quotes" class="collapse">
            <div class="card-body">
                <h1 class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">By budget</h1>
                <div class="box-element box-shadow bg-white margin-top-20 margin-bottom-0 rounded">
                    <div class="box-element-info">
                        <div v-for="(category, index) in byBudget" v-if="category.data.length > 0" class="card">
                            <div class="card-header">
                                <h2 class="mb-0">
                                    <button class="btn btn-link w-100 link-style" data-toggle="collapse" :data-target="'#by-budget-quotes-'+index" aria-expanded="true">
                                        <span class="row justify-content-between">
                                            <span class="col-auto text-left">{{ category.title }}</span>
                                            <span class="col-auto text-right"><i class="material-icons align-middle">keyboard_arrow_down</i></span>
                                        </span>
                                    </button>
                                </h2>
                            </div>
                            <div :id="'by-budget-quotes-'+index" class="collapse">
                                <div class="card-body">
                                    <h1 class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">{{ category.title }}</h1>
                                    <div class="box-element box-shadow bg-white margin-top-20 margin-bottom-0 rounded">
                                        <div class="box-element-info">
                                            <div class="table-responsive-md margin-top-40">
                                                <recent-quotes-table :data="category.data"></recent-quotes-table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- By Destination -->
    <div v-if="Object.keys(byDestination).length > 0" class="card">
        <div class="card-header">
            <h2 class="mb-0">
                <button class="btn btn-link w-100 link-style" data-toggle="collapse" data-target="#by-destination-quotes" aria-expanded="true">
                    <span class="row justify-content-between">
                        <span class="col-auto text-left">By destination</span>
                        <span class="col-auto text-right"><i class="material-icons align-middle">keyboard_arrow_down</i></span>
                    </span>
                </button>
            </h2>
        </div>
        <div id="by-destination-quotes" class="collapse">
            <div class="card-body">
                <h1 class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">By destination</h1>
                <div class="box-element box-shadow bg-white margin-top-20 margin-bottom-0 rounded">
                    <div class="box-element-info">
                        <div v-for="(data, destination, index) in byDestination" class="card">
                            <div class="card-header">
                                <h2 class="mb-0">
                                    <button class="btn btn-link w-100 link-style" data-toggle="collapse" :data-target="'#by-destination-quotes-'+index" aria-expanded="true">
                                        <span class="row justify-content-between">
                                            <span class="col-auto text-left">{{ destination }}</span>
                                            <span class="col-auto text-right"><i class="material-icons align-middle">keyboard_arrow_down</i></span>
                                        </span>
                                    </button>
                                </h2>
                            </div>
                            <div :id="'by-destination-quotes-'+index" class="collapse">
                                <div class="card-body">
                                    <h1 class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">{{ destination }}</h1>
                                    <div class="box-element box-shadow bg-white margin-top-20 margin-bottom-0 rounded">
                                        <div class="box-element-info">
                                            <div class="table-responsive-md margin-top-40">
                                                <recent-quotes-table :data="data"></recent-quotes-table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

</template>

<script>
    import RecentQuotesTable from "./../../components/misc/RecentQuotesTable"

    export default {
        components: { RecentQuotesTable },

        props: {
            loading: {
                type: Boolean,
                default: false
            },
            allRecentQuotes: {
                type: Array,
                default: []
            },
            byNightsStay: {
                type: Object,
                default: {}
            },
            byBudget: {
                type: Array,
                default: []
            },
            byDestination: {
                type: Object,
                default: {}
            },

        },
    }
</script>
